import React from 'react';
import { Link } from 'react-router-dom';
import { contact } from '../Data';
import { FiArrowUpRight, FiCheckCircle, FiShoppingCart, FiBookOpen, FiHeart, FiGlobe } from 'react-icons/fi';

const Hero = () => (
  <div className="alpha-hero">
    <div className="hero-copy">
      <div className="hero-kicker"><span className="live-dot"/> KENYAN-BUILT DIGITAL SOLUTIONS</div>
      <h1>Smart Technology.<br/><span>Better Business.</span></h1>
      <p>Power your business or institution with reliable POS systems, school and hospital platforms, websites, mobile apps and custom software designed around the way you work.</p>
      <div className="hero-actions">
        <Link className="primary-btn premium-btn" to="/portfolio">Explore Our Solutions <FiArrowUpRight/></Link>
        <a className="secondary-btn" href={`https://wa.me/${contact.whatsapp}`}>WhatsApp Us</a>
      </div>
      <div className="trust-row"><span><FiCheckCircle/> Responsive</span><span><FiCheckCircle/> Secure by design</span><span><FiCheckCircle/> Local support</span></div>
    </div>
    <div className="hero-showcase" aria-label="Alpha digital solutions preview">
      <div className="orb orb-one"/><div className="orb orb-two"/>
      <div className="showcase-window">
        <div className="window-bar"><span/><span/><span/><b>ALPHA DIGITAL SUITE</b></div>
        <div className="dashboard-head"><div><small>YOUR BUSINESS</small><strong>Control Centre</strong></div><span className="status-pill">● LIVE</span></div>
        <div className="mini-chart"><span style={{height:'38%'}}/><span style={{height:'62%'}}/><span style={{height:'48%'}}/><span style={{height:'82%'}}/><span style={{height:'68%'}}/><span style={{height:'95%'}}/><span style={{height:'76%'}}/></div>
        <div className="solution-grid">
          <div><i><FiShoppingCart/></i><b>POS</b><small>Sales & Stock</small></div>
          <div><i><FiBookOpen/></i><b>EDU</b><small>School Systems</small></div>
          <div><i><FiHeart/></i><b>HEALTH</b><small>Clinic Systems</small></div>
          <div><i><FiGlobe/></i><b>WEB</b><small>Sites & Apps</small></div>
        </div>
      </div>
      <div className="floating-chip chip-one"><span>✓</span><div><b>Built for Kenya</b><small>KSh · M-Pesa · Printing</small></div></div>
      <div className="floating-chip chip-two"><span>24</span><div><b>Smart workflows</b><small>Simple. Fast. Reliable.</small></div></div>
    </div>
  </div>
);
export default Hero;
